import { useMemo } from 'react';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IBusinessUser } from '../types/businessUser.type';
import { BusinessUserApi } from '../api/businessUser.api';
import { useAppDispatch, useAppSelector } from './store';

const slice = createSlice({
  name: 'businessUser',
  initialState: {} as IBusinessUser,
  reducers: {
    set(state, action: PayloadAction<IBusinessUser>) {
      return action.payload;
    }
  }
});

export const businessUserReducer = slice.reducer;

export function useBusinessUsers() {

  const dispatch = useAppDispatch();

  return useMemo(() => ({

    get() {
      return useAppSelector(state => state.businessUser);
    },

    async fetch() {
      const businessUser = await BusinessUserApi.getBusinessUser();
      dispatch(slice.actions.set(businessUser));
    }
  }), []);
}
